export const getDeviceId = (): string | null => {
  return localStorage.getItem('deviceId');
};

export const setDeviceId = (deviceId: string): void => {
  localStorage.setItem('deviceId', deviceId);
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem('accessToken');
};

export const setAccessToken = (accessToken: string): void => {
  localStorage.setItem('accessToken', accessToken);
};
